import { IconProps } from ".";
import Icon from "./assets/sign_out_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24SignOut(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
